import * as THREE from 'three';

/** Arrow keys travel along the ground; Shift + vertical arrows changes elevation. */
export function arrowNavigationDelta(camera: THREE.Camera, target: THREE.Vector3, key: string, step: number, shift: boolean): THREE.Vector3 {
  if (shift && (key === 'ArrowUp' || key === 'ArrowDown')) return new THREE.Vector3(0, key === 'ArrowUp' ? step : -step, 0);
  if (key === 'ArrowLeft' || key === 'ArrowRight') {
    const right = new THREE.Vector3().setFromMatrixColumn(camera.matrixWorld, 0).setY(0).normalize();
    return right.multiplyScalar(key === 'ArrowRight' ? step : -step);
  }
  const forward = target.clone().sub(camera.position).setY(0);
  if (forward.lengthSq() < 1e-8) forward.setFromMatrixColumn(camera.matrixWorld, 1).setY(0);
  return forward.normalize().multiplyScalar(key === 'ArrowUp' ? step : -step);
}
